import React from 'react';
import MediaQuery from 'react-responsive';
import classnames from 'classnames';

import Button from 'ui/common/button';

import styles from './index.module.scss';

const InfoCards = () => (
  <div className={styles.infoContainer}>
    <div className={classnames(styles.cards)}>
      <div className={classnames(styles.card)}>
        <div className={classnames(styles.cardImage)}>
          <img
            src={'https://indorse-staging-bucket.s3.amazonaws.com/Staking-Mechanism.svg'}
            alt="new-role"
          />
        </div>
        <div className={classnames(styles.cardTitle)}>Staking</div>
        <div className={classnames(styles.cardText)}>
          Participate in the new staking mechanism on Indorse 2.0!
        </div>
        <div className={classnames('text-center pt-3')}>
          <Button color="primary-rect" href="https://ecosystem.indorse.io/stake">
            Participate Now
          </Button>
        </div>
      </div>
      <div className={classnames(styles.card)} style={{ border: '8px solid #2A2498' }}>
        <div className={classnames(styles.cardImage)}>
          <img
            src={'https://indorse-staging-bucket.s3.amazonaws.com/NFT_Icon.png'}
            alt="new-role"
          />
        </div>
        <div className={classnames(styles.cardTitle)}>NFT</div>
        <div className={classnames(styles.cardText)}>Rediscover the world of NFTs.</div>
        <div className={classnames('text-center pt-4')}>
          <Button color="primary-rect" href="https://blockbots.gg/">
            Join the BlockBots
          </Button>
        </div>
      </div>
      <div className={classnames(styles.card)}>
        <div className={classnames(styles.cardImage)}>
          <img src={'https://indorse-staging-bucket.s3.amazonaws.com/DRA.svg'} alt="new-role" />
        </div>
        <div className={classnames(styles.cardTitle)}>DRA</div>
        <div className={classnames(styles.cardText)}>Leverage your network to earn rewards!</div>
        <div className={classnames('text-center pt-4')}>
          <Button color="primary-rect" href="https://ecosystem.indorse.io/referral-agents">
            Collect Rewards
          </Button>
        </div>
      </div>
    </div>
    <div className={classnames(styles.cards)} />
  </div>
);

const WhatsNew = () => {
  const renderDesktop = () => {
    return (
      <div>
        <div className="d-flex align-items-start justify-content-between">
          <div className="col-12 px-0 mt-5">
            <h3 className={classnames(styles.macro, 'mt-3 mx-auto text-left mb-0')}>IND TOKEN</h3>
            <h2 className={classnames(styles.title, 'mt-3 mx-auto text-left')}>What's new</h2>
            <div className="d-flex justify-content-between">
              <p className={classnames(styles.text, 'mb-4')}>
                After the token sale in 2017, the team at Indorse put their heads down and got to
                work. In the last 3 years, Indorse has achieved a lot of great milestones, worked
                with several enterprise clients, and generated revenues in excess of US$ 1 million.
              </p>
              <p style={{ marginTop: '-12px' }} className={classnames(styles.text)}>
                While the team was focusing on creating real business value for Indorse and the
                ecosystem, the blockchain industry and the related technology itself has
                metamorphosed completely. In order to keep up with the times and incorporate the
                latest paradigms in Solidity and the innovations in the token model itself, Indorse
                is upgrading our existing system and token utility models.
              </p>
            </div>
            <div className="mt-5">
              <Button
                color="primary-rect"
                href="https://indorse-staging-bucket.s3.amazonaws.com/Indorse+2.0+Light+Paper.pdf"
              >
                Check out the lightpaper
              </Button>
            </div>
          </div>
          {/* <div className="px-0 mt-0 col-7">
            <img
              src="https://indorse-staging-bucket.s3.amazonaws.com/Ecosystem.svg"
              width="480"
              className="ml-auto"
              alt="hero"
            />
          </div> */}
        </div>
        <InfoCards />
      </div>
    );
  };

  const renderMobile = () => {
    return (
      <div>
        <div className="px-0">
          <h3 className={classnames(styles.macro, 'mt-3 mx-auto')}>IND TOKEN</h3>
          <h2 className={classnames(styles.title, 'mt-3 mx-auto')}>What's new</h2>
          <div>
            <p className={classnames(styles.text, 'mb-4')}>
              After the token sale in 2017, the team at Indorse put their heads down and got to
              work. In the last 3 years, Indorse has achieved a lot of great milestones, worked with
              several enterprise clients, and generated revenues in excess of US$ 1 million.
            </p>
            <p className={classnames(styles.text)}>
              While the team was focusing on creating real business value for Indorse and the
              ecosystem, the blockchain industry and the related technology itself has metamorphosed
              completely. In order to keep up with the times and incorporate the latest paradigms in
              Solidity and the innovations in the token model itself, Indorse is upgrading our
              existing system and token utility models.
            </p>
          </div>
          <div className="d-flex justify-content-center mt-5">
            <Button
              href="https://indorse-staging-bucket.s3.amazonaws.com/Indorse+2.0+Light+Paper.pdf"
              color="primary-rect"
            >
              Check out the lightpaper
            </Button>
          </div>
        </div>
        {/* <div className="px-0 mt-3">
          <img
            src="https://indorse-staging-bucket.s3.amazonaws.com/Ecosystem.svg"
            width="80%"
            className="mx-auto"
            alt="hero"
          />
        </div> */}
        <InfoCards />
      </div>
    );
  };

  return (
    <div className={classnames(styles.lightblue)}>
      <div className={classnames('page-max-width')}>
        <MediaQuery minWidth={'992px'}>
          {/* <AnimatedBackground /> */}
          {renderDesktop()}
        </MediaQuery>
        <MediaQuery maxWidth={'991px'}>{renderMobile()}</MediaQuery>
      </div>
    </div>
  );
};

export default WhatsNew;
